<div
  class="repricing-recommend-analysis-content"
  [ngClass]="isFitGrid && 'fit-grid'"
>
  <div>
    <span class="section-label">1. Current Metrics</span>

    <div class="params-grid">
      <div class="param-box" [ngbTooltip]="'Sales Velocity'">
        <span class="param-val">🔥 {{ repricingItem?.context?.velocity }}</span>
        <span class="param-key">units/day</span>
      </div>
      <div class="param-box custom-tooltip-container">
        <span class="param-val"
          >📦 {{ repricingItem?.context?.inventory }}</span
        >
        <span class="param-key">Inventory</span>

        <div class="custom-tooltip-popup text-left">
          <div class="inventory-table-container">
            <table class="table table-striped inventory-table mb-0">
              <thead>
                <tr>
                  <th>Inventory Source</th>
                  <th class="text-right">Units</th>
                </tr>
              </thead>
              <tbody>
                <ng-container *ngFor="let row of inventoryRows; let last = last">
                <tr *ngIf="!row.hidden" [class.total-row]="row.isTotalRow">
                  <td>
                    <span>{{ row.label }}</span>
                    <i
                      *ngIf="row.info"
                      class="feather icon-info ml-1 text-muted"
                      [ngbTooltip]="row.info"
                      placement="right"
                      tooltipClass="tooltip-high-zindex"
                    ></i>
                  </td>
                  <td class="text-right inventory-table__row-data" [class.fw-bold]="last">{{ row.value }}</td>
                </tr>
                </ng-container>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="param-box" [ngbTooltip]="'Stock Days'">
        <span class="param-val"
          >📉 {{ repricingItem?.context?.daysOfInventory || 0 }}</span
        >
        <span class="param-key">Stock Days</span>
      </div>
      <div
        class="param-box"
        [ngbTooltip]="
          'Restock Days ' +
          '(' +
          (repricingItem?.context?.restockDate | date : FORMAT_DATE) +
          ')'
        "
      >
        <span class="param-val"
          >🚚 {{ repricingItem?.context?.restockDays }}</span
        >
        <span class="param-key">Restock Days</span>
      </div>
    </div>
  </div>

  <div>
    <span class="section-label">2. Logic Applied</span>

    <div class="formula-box">
      <app-asc-repricing-formula
        [repricingItem]="repricingItem"
        [isWrap]="isFitGrid"
      >
      </app-asc-repricing-formula>
    </div>
  </div>

  <div class="inventory-health">
    <app-repricing-inventory-health
      [state]="repricingItem?.state"
      [riskRatio]="repricingItem?.riskRatio"
    ></app-repricing-inventory-health>
  </div>

  <div>
    <span class="section-label">3. Conclusion</span>

    <div class="result-box"
      [class.increase]="repricingItem?.trendPercentage > 0"
      [class.decrease]="repricingItem?.trendPercentage < 0"
      [ngClass]="getResultClass()"
    >
      <div
        class="result-text"
        *ngIf="
          REPRICING_INVENTORY_STATUS_STATE_DISPLAY[repricingItem?.state]
            ?.conclusion as conclusion
        "
      >
        <h4>{{ conclusion.title }}</h4>
        <p>{{ conclusion.description }}</p>
      </div>
      <div class="result-tag" *ngIf="!isSpecialState">
        <div class="result-tag__label">Recommended</div>
        <div class="result-tag__description">
          <ng-container *ngIf="!repricingItem?.trendPercentage; else rcmChange">
            Maintain
          </ng-container>
          <ng-template #rcmChange>
            {{ repricingItem?.trendPercentage }}%
            {{ repricingItem?.trendPercentage > 0 ? "Increase" : "Decrease" }}
          </ng-template>
        </div>
      </div>
    </div>
  </div>
</div>
